export default {
  plural: 'Selected lifestyles',
  download: 'Download'
};
